/**
 * The default values for payment line item forms to prevent stale values from
 * showing up in the form.
 * See https://github.com/orgs/react-hook-form/discussions/8364
 */

import { getSelectOptionFromValue, paymentAmountOptions, rateCategoryOptions } from './select-options';

export const basicRateFormDefault = {
    basis: null,
    rate: null,
    milkType: null,
    component: null,
    minCharge: null,
    maxCharge: null,
    applyPerPickup: null,
    complexRate: false,
    rateFormula: '',
};

export const rateFormDefault = {
    rate_name: '',
    description: null,
    subcategory: null,
    paid_by_payer: true,
    paid_to_payee: getSelectOptionFromValue(paymentAmountOptions, 'amount_paid'),
    payee_category: getSelectOptionFromValue(rateCategoryOptions, 'gross_pay'),
    payer_category: getSelectOptionFromValue(rateCategoryOptions, 'deduction'),
    rulesType: null,
    gl_number: null,
    account: null,
    reference: null,
    rate: basicRateFormDefault,
    rules: [],
    average_override: null,
    basis_parameter_filter: {
        exclude_pickups_before_date: null,
        exclude_pickups_after_date: null,
        include_producer_ids: null,
        exclude_producer_ids: null,
        processor_ids: null,
        hauler_ids: null,
        route_ids: null,
        pay_to_pickup_hauler: false,
    },
};

export const tieredRateFormDefault = {
    when: null,
    amount: null,
    rate: null,
    basis: null,
    component: null,
    milkType: null,
    complexRate: false,
    rateFormula: '',
    conditions: [
        {
            criteria: null,
            condition: null,
            amount: null,
            amountUpper: null,
        },
    ],
    minCharge: null,
    maxCharge: null,
    applyPerPickup: null,
};

export const tieredRateConditionFormDefault = {
    criteria: null,
    condition: null,
    amount: null,
    amountUpper: null,
};
